import React, { useState } from "react";
import { MdPersonSearch } from "react-icons/md";
import { HiComputerDesktop } from "react-icons/hi2";
import { LuHotel } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";
import { Box, Stack, Typography, IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { connect } from "react-redux";
import { House, MonitorPlay, Robot } from "@phosphor-icons/react";
import { setCurrentTab, setUserlistShow } from "../../../Redux/Actions/actions";
import CustomerDetailSearchNew from "./Customer-Detail-Search/Customer-Detail-Search-New";
const mapStateToProps = (state) => {
  const { contactListData, data } = state;
  return {
    userlistshow: data.userlistshow,
    externalChatData: contactListData.externalChatData,
    chatBotLink: contactListData.chatBotLink,
    videoChatLink: contactListData.videoChatLink,
    cobrowsChatLink: contactListData.cobrowsChatLink,
    CurrentTab: contactListData.CurrentTab,
  };
};
const UserDetailsHeader = (props) => {
  const [CustomerDetailSearch, setCustomerDetailSearch] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          background: "white",
          padding: "5px 10px",
        }}
        className="border-bottom card-header"
      >
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#0b3363",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            {(() => {
              switch (props.CurrentTab) {
                case "customerDetails":
                  return "Customer Details";
                case "Crm":
                  return "CRM";
                case "Chatbot":
                  return "ChatBot";
                default:
                  return "Customer Details";
              }
            })()}
          </Typography>
        </Box>
        <Stack direction={"row"} alignItems={"center"} spacing={0.1}>
          <Tooltip title={"Customer Detail"} arrow placement="top">
            <IconButton
              onClick={() => {
                props.setCurrentTab("customerDetails");
              }}
            >
              <House size={16} weight="bold" />
            </IconButton>
          </Tooltip>
          {JSON.parse(localStorage.getItem("permission")).map(
            (module, index) => {
              if (module.moduleName === "INTERACTION") {
                const crmScreen = module.screen.find(
                  (item) =>
                    item.screenId === "CUSTOMER_SEARCH" &&
                    item.read &&
                    item.write
                );

                if (crmScreen) {
                  return (
                    <Tooltip
                      key={index}
                      title={"Customer Search"}
                      arrow
                      placement="top"
                    >
                      <IconButton
                        onClick={() => {
                          setCustomerDetailSearch(true);
                        }}
                      >
                        <MdPersonSearch size={14} />
                      </IconButton>
                    </Tooltip>
                  );
                } else {
                  return (
                    <Tooltip
                      key={index}
                      title="Contact Admin"
                      arrow
                      placement="top"
                    >
                      <IconButton>
                        <MdPersonSearch size={14} />
                      </IconButton>
                    </Tooltip>
                  );
                }
              }
            }
          )}
          {JSON.parse(localStorage.getItem("permission")).map(
            (module, index) => {
              if (module.moduleName === "INTERACTION") {
                const crmScreen = module.screen.find(
                  (item) =>
                    (item.screenId === "CRM_CHAT"&& item.read && item.write) ||
                    (item.screenId === "CRM_VOICE" && item.read && item.write)||
                    (item.screenId === "CRM_PURPLE" && item.read && item.write)
                );

                if (crmScreen) {
                  return (
                    <Tooltip key={index} title={"CRM"} arrow placement="top">
                      <IconButton
                        onClick={() => {
                          props.setCurrentTab("Crm");
                        }}
                      >
                        <HiComputerDesktop size={13} />
                      </IconButton>
                    </Tooltip>
                  );
                } else {
                  return (
                    <></>
                    // <Tooltip
                    //   key={index}
                    //   title="Contact Admin"
                    //   arrow
                    //   placement="top"
                    // >
                    //   <IconButton>
                    //     <HiComputerDesktop size={13} />
                    //   </IconButton>
                    // </Tooltip>
                  );
                }
              }
            }
          )}
          {JSON.parse(localStorage.getItem("permission")).map(
            (module, index) => {
              if (module.moduleName === "INTERACTION") {
                const crmScreen = module.screen.find(
                  (item) =>
                    item.screenId === "HOSPITALITY" && item.read && item.write
                );

                if (crmScreen) {
                  return (
                    <Tooltip title={"Hospitality"} arrow placement="top">
                      <IconButton
                        onClick={() => {
                          props.setCurrentTab("Hospitality");
                        }}
                      >
                        <LuHotel size={13} />
                      </IconButton>
                    </Tooltip>
                  );
                } else {
                  return (
                    <Tooltip
                      key={index}
                      title="Contact Admin"
                      arrow
                      placement="top"
                    >
                      <IconButton>
                        <LuHotel size={13} />
                      </IconButton>
                    </Tooltip>
                  );
                }
              }
            }
          )}
          {props.chatBotLink.type == "chatBot" &&
          props.externalChatData.chat_session_id ==
            props.chatBotLink.chat_session_id ? (
            <Tooltip title={"Chatbot"} arrow placement="top">
              <IconButton
                onClick={() => {
                  props.setCurrentTab("Chatbot");
                }}
              >
                <Robot size={16} weight="bold" />
              </IconButton>
            </Tooltip>
          ) : (
            <></>
          )}
          <Tooltip
            title={
              props.userlistshow ? "Hide Interactions" : "Show Interactions"
            }
            arrow
            placement="top"
          >
            <IconButton
              onClick={() => {
                props.setUserlistShow(!props.userlistshow);
              }}
            >
              <IoIosArrowForward
                size={16}
                className={
                  props.userlistshow
                    ? "userInfo-rotate-90"
                    : "userInfo-rotate-0"
                }
              />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>

      {CustomerDetailSearch && (
        <CustomerDetailSearchNew
          OpenDialog={CustomerDetailSearch}
          handleClose={() => {
            setCustomerDetailSearch(false);
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  setUserlistShow,
  setCurrentTab,
})(UserDetailsHeader);
